module.exports = __webpack_public_path__ + "img/65.a7dc8df9.jpg";